export default __webpack_public_path__ + "static/media/question-answer-line.1823e50b.svg";